<button mat-button class="ribbon-button-padding">
        <mat-icon class="edit-icon" [class]="theme.myIconColor">edit</mat-icon> 
        <span>Edit</span> 
</button>
